import React from 'react'
import { Snackbar, Button, Box } from '@mui/material'

const AppUpdateSnackbar = ({ isVisible, onUpdate, onDismiss, theme }) => (
	<Snackbar
		anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
		open={isVisible}
		message={
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					textAlign: 'center'
				}}
			>
				<span>A new version of the app is available.</span>
				<Box
					sx={{
						display: 'flex',
						gap: 1,
						marginTop: 1
					}}
				>
					<Button
						disableRipple
						size="small"
						sx={{
							backgroundColor: theme.palette.primary.main,
							color: '#FFFFFF',
							textTransform: 'none',
							'&:hover, &:active, &:focus': {
								backgroundColor: theme.palette.primary.main,
								color: '#FFFFFF'
							}
						}}
						onClick={onUpdate}
					>
						Refresh
					</Button>
					<Button
						disableRipple
						size="small"
						sx={{
							backgroundColor: '#FFFFFF',
							color: theme.palette.primary.main,
							border: `1px solid ${theme.palette.primary.main}`,
							textTransform: 'none',
							'&:hover, &:active, &:focus': {
								backgroundColor: '#FFFFFF',
								color: theme.palette.primary.main,
								border: `1px solid ${theme.palette.primary.main}`
							}
						}}
						onClick={onDismiss}
					>
						I&apos;ll refresh later
					</Button>
				</Box>
			</Box>
		}
		ContentProps={{
			sx: {
				border: `2px solid ${theme.palette.primary.main}`,
				fontWeight: 'bold',
				textAlign: 'center',
				color: theme.palette.primary.main,
				backgroundColor: '#FFFFFF',
				'& .MuiSnackbarContent-message': {
					width: '100%'
				}
			}
		}}
	/>
)

export default AppUpdateSnackbar
